<template>
  <price :value="price"></price>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Purchase from '@/api/purchase'
  import { Price } from '@/components/formatters'
  import purchase from '@/mixins/purchase'
  export default {
    components: {
      Price
    },
    mixins: [purchase],
    computed: {
      ...mapGetters({
        platform: 'skiliko/session/currentPlatform',
        currentUser: 'skiliko/session/currentUser'
      }),
      price () { return Purchase.totalPrice(this.purchase, this.platform, this.currentUser) }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/TotalPrice.vue